import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Grid,
  Link,
} from "@material-ui/core";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Button } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PhysiciansReportControl from "../PhysiciansReportControl/PhysiciansReportControl";
import { requestNearbyPhysicians } from "../../api";
import DHPic from "../../images/Dr-haiel3.png";
import ReportGraph from "../ReportGraph/ReportGraph";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { InfoOutlined } from "@material-ui/icons";

const useStyles = makeStyles({
  root: {
    maxWidth: 740,
  },
  media: {
    height: 300,
  },
  avt: {
    marginBottom: 20,
    "&:before": {
      backgroundImage: `url(${DHPic})`,
      backgroundSize: "30px 30px",
      backgroundRepeat: "no-repeat",
      content: '""',
      position: "absolute",
      left: 10,
      width: 30,
      height: 30,
    },
  },
  bot: {
    maxWidth: 740,
  },
  btn: {
    width: "100%",
    backgroundColor: "#1EB0BC",
    opacity: 0.7,
    color: "#fff",
    padding: 15,
    fontSize: "1rem",
    fontWeight: "bold",
  },
});

const useStyles2 = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PhysiciansReportCard = ({
  specialty,
  zip,
  radius,
  onUserInput,
  chatHistory,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [stage, setStage] = React.useState(0);

  const [loot, setloot] = React.useState([]);

  const [abort, setAbort] = React.useState(false);

  const [loading, setLoading] = React.useState(false);

  const switchStage = (event, newValue) => {
    setStage(newValue);
  };

  const extractInformation = async (specialty, zip, radius) => {
    console.log("PhysiciansReportCard Reuqest: ", specialty, zip, radius);
    // for east 'jump to' debug
    if (!specialty) {
      specialty = "General Practitioner";
    }
    if (!zip) {
      zip = "19104";
    }
    if (!radius) {
      radius = 5;
    }
    if (!abort) {
      setLoading(true);
      let result = [];
      // if (da == 'General') {
      //   console.log('PhysiciansReportCard Reuqest: requestTopHospitals');
      //   result = await requestTopHospitals(dkw);
      // } else {
      //   console.log('PhysiciansReportCard Reuqest: requestReportTopHospitals');
      //   result = await requestReportTopHospitals(dkw, da);
      // }
      result = await requestNearbyPhysicians(specialty, zip.trim(), radius);
      setLoading(false);
      console.log("Already  got the NearbyPhysicians data", result);
      setloot(result);
    } else {
      console.log("Async abort");
    }
  };

  useEffect(() => {
    // Update the document title using the browser API
    console.log("Start extraction");
    extractInformation(specialty, zip, radius); // wait for 30 seconds
    if (loot) {
      return;
    } else {
      setTimeout(() => {
        console.log("Wait for the loot to come out!");
      }, 180000);
    }
  }, []);

  function TabPanel(props) {
    const { propsLoot, value, index } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={index}
        aria-labelledby={index}
      >
        {value === index && (
          <PhysiciansReportControl loot={propsLoot} value={value} zip={zip} />
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    propsLoot: PropTypes.object.isRequired,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  return (
    <Fragment>
      <div className={classes.avt}>_</div>
      <Card
        className={(classes.root, classes.bot)}
        style={{
          marginBottom: "20px",
          backgroundColor: "#E3F5F7",
        }}
      >
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
            style={{ fontSize: "1.25rem" }}
          >
            {specialty} physicians near {zip} ({radius} miles)
          </Typography>

          <Accordion>
            <AccordionSummary
              expandIcon={<InfoOutlined />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                {loot &&
                  `${
                    loot.physiciansNearBy ? loot.physiciansNearBy.length : 0
                  } physicians and ${
                    loot.clinicsNearBy ? loot.clinicsNearBy.length : 0
                  } clinics/hospitals.`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <Typography
                  variant="h5"
                  component="h2"
                  style={{ fontSize: "1rem" }}
                >
                  {/* Something goes there ... */}
                </Typography>
              </Box>
            </AccordionDetails>
          </Accordion>
        </CardContent>
        <CardActionArea />
        {loading ? (
          <CardContent>
            <Box textAlign="center">
              <CircularProgress />
            </Box>
          </CardContent>
        ) : (
          <CardContent>
            <Box sx={{ backgroundColor: "#fff" }}>
              <AppBar position="static" color="default">
                <Tabs
                  value={stage}
                  onChange={switchStage}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab label="Doctors" value={0} />
                  <Tab
                    label={
                      specialty === "General Practitioner"
                        ? "Clinics"
                        : "Hospitals"
                    }
                    value={1}
                  />
                  <Tab label="Map" value={2} />
                  {/* <Tab label="How Selective?" value={4} /> */}
                </Tabs>
              </AppBar>
              <TabPanel
                value={stage}
                index={0}
                dir={theme.direction}
                propsLoot={loot}
              />
              <TabPanel
                value={stage}
                index={1}
                dir={theme.direction}
                propsLoot={loot}
              />
              <TabPanel
                value={stage}
                index={2}
                dir={theme.direction}
                propsLoot={loot}
              />
            </Box>
          </CardContent>
        )}
        <CardActions style={{ justifyContent: "center" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Button type="button" className={classes.btn}>
                <Link
                  href="https://linkmedicine.com/contact-dr-haiel/"
                  underline="none"
                  variant="inherit"
                  target="_blank"
                  style={{ color: "white" }}
                >
                  Request More Information
                </Link>
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button type="button" className={classes.btn}>
                <Link
                  href={`https://linkmedicine.com`}
                  underline="none"
                  variant="inherit"
                  target="_blank"
                  style={{ color: "white" }}
                >
                  Access Full report(beta)
                </Link>
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button type="button" className={classes.btn}>
                Seek Navigation Service
              </Button>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </Fragment>
  );
};
PhysiciansReportCard.propTypes = {
  onUserInput: PropTypes.func.isRequired,
  isLastMessage: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool,
};
PhysiciansReportCard.defaultProps = {
  isSelected: false,
};

export default PhysiciansReportCard;



// WEBPACK FOOTER //
// ./src/components/PhysiciansReportCard/PhysiciansReportCard.js